export class Constants {
    public static APP_NAME: string = 'Hoeca';
    public static API_BASE_URL: string = 'https://api.horecaretailexpo.ro';
    // public static API_BASE_URL: string = 'http://192.168.201.94:8000:8000';
    public static ENABLE_DELETE = true; // make sure this is set to true in production environment
}
